import { render, staticRenderFns } from "./SurveyQualificationOpenEnd.vue?vue&type=template&id=2b0af856&scoped=true&"
import script from "./SurveyQualificationOpenEnd.vue?vue&type=script&lang=js&"
export * from "./SurveyQualificationOpenEnd.vue?vue&type=script&lang=js&"
import style0 from "./SurveyQualificationOpenEnd.vue?vue&type=style&index=0&id=2b0af856&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0af856",
  null
  
)

export default component.exports